/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_USERINGENERALPOOL_DATA, USERINGENERALPOOL_DATA_RECEIVED } = constants.ViewUserInGeneralPool;

export default {
    REQUEST_USERINGENERALPOOL_DATA,
    USERINGENERALPOOL_DATA_RECEIVED,

  requestuserInGeneralPoolData: () => ({
    type: REQUEST_USERINGENERALPOOL_DATA,
  }),
  userInGeneralPoolDataReceived: () => ({
    type: USERINGENERALPOOL_DATA_RECEIVED
  }),
};
